

export const DIALOG_TYPE = 'DIALOG_HELP_SUPPORT';
